module.exports = __webpack_public_path__ + "img/shier.c51cfb88.png";